import React from "react";
import { useState, useEffect } from "react";

import { Col, Row } from "react-bootstrap";
import {
  IoIosArrowUp,
  IoIosArrowDown,
  IoIosArrowForward,
} from "react-icons/io";

import { PALETTE } from "../../common/ThemeConstants";
import UserWorkoutList from "./UserWorkoutList";
import UserExerciseMaximumList from "./UserExerciseMaximumList";
import UserSubscription from "./UserSubscription";
import UserAvatar from "../../common/components/UserAvatar";
import PremiumTag from "../../common/components/PremiumTag";

export default function CardAdminUser({ user, height = 100, editCallback }) {
  const [isSelected, setIsSelected] = useState(false);

  async function fetchData() { }

  useEffect(() => {
    fetchData();
  }, []);

  return (
    <div
      className="my-2 shadow-sm rounded-md"
      style={{ border: "solid 0px", backgroundColor: PALETTE.WHITE }}
    >
      <Row
        className="g-0 align-items-center"
        style={{ height: height, cursor: "pointer" }}
        onClick={() => {
          editCallback(user.id);
        }}
      >
        <Col xs={2} className="text-start" style={{ paddingLeft: "8px" }}>
          <UserAvatar
            firstname={user.firstname}
            lastname={user.lastname}
            background={PALETTE.GRADIENTLIGHT}
            size={40}
            fontSize={14}
            cover={user.cover || undefined}
          />
        </Col>
        <Col xs={6} className="text-start" style={{ paddingLeft: "4px" }}>
          <p className="mb-0 cardDescription">
            {user.firstname} {user.lastname}
          </p>
          <p
            className="cardDescription"
            style={{ marginBottom: "2px", color: PALETTE.DARKGRAY }}
          >
            {user.email}
          </p>
        </Col>
        <Col xs={2} className="text-end">
          {user.premium && (<PremiumTag />)}
        </Col>
        <Col xs={2} className="align-self-center text-end px-2">
          <IoIosArrowForward size={25} color={PALETTE.GRAY} />
        </Col>
      </Row>
      {isSelected && (
        <>
          <UserSubscription user={user} />
          <UserWorkoutList user={user} />
          <UserExerciseMaximumList user={user} />
        </>
      )}
      <Row
        className="py-2 g-0 align-items-center rounded-md-bottom"
        style={{
          cursor: "pointer",
          backgroundColor: PALETTE.LIGHTGRAY,
          width: "100%",
        }}
        onClick={() => setIsSelected(!isSelected)}
        size={25}
      >
        <Col className="align-self-center text-center">
          {isSelected && <IoIosArrowUp size={25} color={PALETTE.GRAY} />}
          {!isSelected && <IoIosArrowDown size={25} color={PALETTE.GRAY} />}
        </Col>
      </Row>
    </div>
  );
}
